<template>
    <section class="signup-section spad set-bg">
        <div class="signup-warp d-flex">
            <!-- signup form -->
            <div class="signup-container ml-auto mr-auto mt-sm-5">
                <div class="signup-warp" v-if="validated == null">
                    <div class="signup-form m-3 m-sm-0 pt-5">
                        <p class="h2 mb-4">Verificación de cuenta</p>
                        <div class="loader-container">
                            <div class="loader"></div>
                        </div>
                    </div>
                </div>
                <div class="signup-warp" v-else-if="validated == true">
                    <div class="signup-form text-left m-3 m-sm-0 pt-5">
                        <p class="h2 mb-4">¡Email verificado correctamente!</p>
                        <h5 class="mb-3">¡Enhorabuena, ya estás dentro!</h5>
                        <div class="text-muted">Inicia sesión en la plataforma y accede a todos tus cursos Chachi Guitar de forma online. También podrás descargarlos.</div>
                        <br>
                        <router-link to="/login" class="d-table m-auto">
                            <button class="site-btn header-btn">Iniciar sesión</button>
                        </router-link>
                    </div>
                </div>
                <div class="signup-warp" v-else-if="validated == false">
                    <div class="signup-form text-left m-3 m-sm-0 pt-5">
                        <p class="h2 mb-4">¡Ooops! Parece que ha habido un error...</p>
                        <h5 class="mb-3">Se ha producido un error al tratar de verificar tu email y activar tu cuenta. Inténtalo de nuevo en unos minutos.</h5>
                        <div class="text-muted">Si el error persiste, contacta con nosotros enviándonos un correo electrónico a <a href="mailto:hola@chachiguitar.com" target="_blank">hola@chachiguitar.com</a></div>
                    </div>
                </div>
            </div>
		</div>
	</section>
</template>

<script>
import axios from 'axios';
import { API_URL } from '@/config.js'

export default {
    name: 'register',
    data() {
        return {
            validated: null
        }
    },
    created() {
        if (this.$route.params.chunk) {
			axios.post(`${API_URL}/public/user/verify`, { "token": this.$route.params.chunk })
				.then(response => {
                    console.log(response)
                    if (response.status == 200) {
                        this.validated = response.data.result
                        if (response.data.result == true) {
                            axios.post(`${API_URL}/public/user/sync`, { email: response.data.email })
                                .then(response => {
                                    console.log(response);
                                })
                                .catch((e) => {
                                    console.error(e)
                                });
                        }
                    } else {
                        this.validated = false
                    }
				})
				.catch(() => {
                    this.validated = false
				});
        } else {
            this.validated = false
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/variables.scss";

    .signup-section {
        min-height: calc(100vh - 48px);
        padding-top: $header-unauth-height;
        background-color: $main-color-brown;
        background-image: url("https://www.justcompileit.com/videos/cursos-streaming/images/register.jpg");
        .signup-container {
            .signup-warp {
                width: 100vw;
                max-width: 700px;
                box-sizing: border-box;
                padding: 0 !important;
            }
        }
        .loader-container {
            background: white;
            padding: 40px 0;
        }
        .validate-container {
            background: white;
            padding: 20px;
            text-align: left;
        }
    }
</style>

